var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: {
            form: _vm.form,
            "label-position": "top",
            rules: _vm.rules,
            "label-width": "120px",
          },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("ChannelManagement.new.title"))),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.DisableDate"),
                    prop: "date",
                  },
                },
                [
                  _c("BjDatePicker", {
                    attrs: { placeholder: _vm.$t("billingPage.DisableDate") },
                    on: { change: _vm.timeChange },
                    model: {
                      value: _vm.form.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "date", $$v)
                      },
                      expression: "form.date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("table.remarkText"), prop: "remarks" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.NORMAL_REMARK,
                      type: "textarea",
                      "show-word-limit": "",
                      autosize: "",
                      placeholder: _vm.$t("table.remarkText"),
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }